import { useCallback, useState } from "react";
import { useFullscreenLayoutEffect } from "./useFullscreenLayoutEffect";

export const useFullscreenPanel = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const exitFullscreen = useCallback(() => setIsFullscreen(false), []);
  const toggleFullscreen = useCallback(
    () => setIsFullscreen((current) => !current),
    [],
  );

  useFullscreenLayoutEffect(isFullscreen, exitFullscreen);

  return {
    exitFullscreen,
    isFullscreen,
    toggleFullscreen,
  };
};
